import { Link } from "react-router-dom";
import { useQuery } from "../api/useQuery";
import { fmtDistance, fmtDuration, fmtTime } from "./format";
import type { PatrolBrief } from "../api/types";
import { reviewBadge } from "./SupervisorNotes";

/** Обходы внутри смены. Загружаются по требованию, при раскрытии строки. */
export function ShiftPatrols({ shiftId }: { shiftId: string }) {
  const { data, error, loading } = useQuery<{ items: PatrolBrief[] }>(
    `/api/v1/shifts/${shiftId}/patrols`,
  );

  if (loading) return <p className="muted small">Загрузка обходов…</p>;
  if (error) return <div className="error">{error}</div>;
  if (!data || data.items.length === 0) {
    return <p className="muted small">В смене нет обходов.</p>;
  }

  return (
    <ul className="plain">
      {data.items.map((p) => (
        <li key={p.id}>
          <Link to={`/patrols/${p.id}`}>{p.route_name ?? "Внеплановый обход"}</Link>{" "}
          <span className="muted small">
            {fmtTime(p.started_at)} · {fmtDuration(p.started_at, p.ended_at)} ·{" "}
            {fmtDistance(p.distance_m)} · {p.points} точек
          </span>
          <div style={{ marginTop: 2 }}>
            <span className="badge ok">точек пройдено: {p.counted_points}</span>{" "}
            {p.missed_points > 0 && <span className="badge danger">не пройдено: {p.missed_points}</span>}{" "}
            {p.gaps > 0 && <span className="badge warn">пробелов: {p.gaps}</span>}
            {p.status === "active" && <span className="badge warn">обход не завершён</span>}{" "}
            {reviewBadge(p.review)}{" "}
            {p.pending_files > 0 && <span className="badge warn">синхронизирован частично</span>}
          </div>
          {/* Названия точек: что пройдено и что осталось, без открытия обхода. */}
          {p.counted_names.length > 0 && (
            <div className="muted small">Пройдены: {p.counted_names.join(", ")}</div>
          )}
          {p.missed_names.length > 0 && (
            <div className="small" style={{ color: "var(--danger)" }}>
              Не пройдены: {p.missed_names.join(", ")}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
